export default [
  {
    fullName: 'Станислав Кузубов',
    jobTitle: 'Бизнес-аналитик, Центр компетенций по системам управления ИТ и мониторинга <b>Холдинга Т1</b>',
    description: 'Приглашённый лектор по направлению Process Mining </br> <b>НИУ ВШЭ</b>',
    photo: require('@/assets/speakers/speaker_kuzubov.jpg')
  }
]
